module.exports = __webpack_public_path__ + "static/img/validCode.b7578e21.svg";